import React, { Component } from 'react';
import ItemCategory from './components/ItemCategory';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import commonUtil from '../../utils/commonUtil';
import {
  isContentLoaded,
  loadContent,
} from '../BrowseAndNavigate/MesaHomePage/actions';
import MarketingContentSection from '../BrowseAndNavigate/MarketingContentSection';

const cms_page_id = 'faq-page';

const BreadcrumbComponent = () => {
  const brand = commonUtil.getBrand();
  const colors = {
    LP: '#E10098',
    GAP: '#122344',
    PB: '#970400',
    PBK: '#74b0e2',
    WS: '#e81818',
    WLM: '#ed2724',
    TRU: '#007bff',
  };
  return (
    <div className='giftBreadcrumbs'>
      <ul>
        <li>
          <a style={{ cursor: 'pointer' }}> Home </a>
          <i className='icon-caret_right' />
        </li>
        <li>
          <a style={{ cursor: 'pointer' }} href='/'>
            Mesa de Regalos
          </a>
          <i className='icon-caret_right' />
        </li>
        <li>
          <a style={{ color: colors[brand], cursor: 'pointer' }}>
            Preguntas frecuentes
          </a>
        </li>
      </ul>
    </div>
  );
};

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isContentLoaded(getState())) {
        return dispatch(loadContent(cms_page_id));
      }
      return undefined;
    },
  },
])
@connect(
  (store) => ({
    store: store,
    content: store.getMarketingLandingPage.data,
  }),
  {
    isContentLoaded,
    loadContent,
  },
)
class FAQPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      channel: commonUtil.getChannel(),
      constChannels: commonUtil.getClientConstForChannel(),
      categories: [],
    };
  }

  render() {
    const { content, store } = this.props;
    return (
      <React.Fragment>
        {this.state.channel === this.state.constChannels.WEB && (
          <BreadcrumbComponent />
        )}
        <MarketingContentSection contentSection={content} store={store} />
      </React.Fragment>
    );
  }
}

export default FAQPage;
